import qs from 'qs'
import * as DataActions from '../actions/Data'
import * as GlobalActions from '../actions/Global'
import * as LogActions from '../actions/Logs'
import { getJSON } from '../common/services/api'
import { showToast } from '../common/utils'

export const fetchLogs = (localState) => {
  return (dispatch, getState) => {
    dispatch(GlobalActions.toggleLoading())

    const query = constructQueryFromState(getState(), localState)
    const url = `/api/list/logs?${query}`
    return getJSON({ url })
      .then((res) => {
        dispatch(LogActions.setLogsCount(res.count))
        dispatch(DataActions.setLoadedList('logs', res.result))
        dispatch(GlobalActions.toggleLoading())
      })
      .catch((err) => {
        dispatch(GlobalActions.toggleLoading())
        console.log(err)
      })
  }
}

export const fetchLogsCsv = (localState, allLogs) => {
  return (dispatch, getState) => {
    dispatch(LogActions.toggleLogsExporting())

    const query = allLogs ? '' : constructQueryFromState(getState(), localState)

    getJSON({ url: `/api/list/logs/export?${query}` })
      .then((res) => {
        removeRefreshAlert()
        dispatch(LogActions.toggleLogsExporting())
        showToast({
          title:
            "You'll receive an email with a link to download the CSV shortly (longer for large files)"
        })
      })
      .catch((e) => {
        removeRefreshAlert()
        dispatch(LogActions.toggleLogsExporting())
        showToast({
          title:
            'Oops. Something went wrong. Please contact support if this problem persists.',
          type: 'error'
        })
      })
  }
}

const constructQueryFromState = (state, localState) => {
  const { search, timeLogged } = localState
  const {
    global,
    logs: { page }
  } = state

  const filters =
    timeLogged && Object.keys(timeLogged).length
      ? { ...global.filters.logs, timeLogged }
      : global.filters.logs || {}

  const query = {
    adminQuery: true,
    filters: {
      ...filters,
      ...(filters.doneBySu ? { doneBySu: filters.doneBySu?.[0] } : {})
    },
    limit: page.size,
    search,
    skip: (page.number - 1) * page.size,
    sort: global.sortTypes.logs
  }

  return qs.stringify(query)
}

const checkIfUserWillRefresh = (e) => {
  e.returnValue = true
  return 'true'
}

const removeRefreshAlert = () =>
  window.removeEventListener('beforeunload', checkIfUserWillRefresh)
